var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    alert: true,
    'alert--success': _vm.variant === 'success',
    'alert--danger': _vm.variant === 'danger',
    'alert--info': _vm.variant === 'info'
  },attrs:{"role":"alert"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }